// import * as types from '@/store/mutation-types'

// TODO: comments, cleanup

// state
const limitsModel = {
  boards: false,
  queries: false,
  medias: false,
  feeds: false,
  domains: false,
}

export const state = {
  ...limitsModel,
}

// getters
export const getters = {
  get_limits: (state) => (key) => {
    if (typeof state[key] !== 'undefined') {
      return state[key]
    }
    return false
  },

  validate_limit: (state) => (key, count) => {
    if (typeof state[key] !== 'number') {
      return true
    } else {
      return (state[key] && state[key] > count) || false
    }
  },
}

// mutations
export const mutations = {
  INIT(state, data) {
    // counts with limit
    state.boards = typeof data.type.max_boards === 'number' ? data.type.max_boards : false
    // state.queries = typeof data.type.max_queries === 'number' ? data.type.max_queries : false
    state.medias = typeof data.type.max_medias === 'number' ? data.type.max_medias : false
    state.feeds = typeof data.type.max_feeds === 'number' ? data.type.max_feeds : false
    state.domains = typeof data.type.max_domains === 'number' ? data.type.max_domains : false
  },

  INCREMENT_COUNT(state, { type, value = 1 }) {
    state[type].count += value
  },

  DECREMENT_COUNT(state, { type, value = 1 }) {
    state[type].count -= value
  },

  RESET(state) {
    Object.keys(state).forEach((key) => {
      state[key] = limitsModel[key]
    })
  },
}

// actions
export const actions = {}
